module.exports = __webpack_public_path__ + "img/优秀组织奖@2x.45b413ca.png";